<template>
  <div>
    <div class="text-sm text-gray-400">
      <button @click="goBack" class="btn_arrow">
        <span class="lft_arrow">
          <ArrowDownBlackIcon :style="{ width: '13px' }" color="grey" />
        </span> Back
      </button>
      <b class="font-semibold mx-3 text-base text-black-default"> Earnings & Payouts </b>
      Billings & Collections > Collections
    </div>
    <section class="bg-white my-4 p-3">
      <div class="flex items-center justify-between mb-4 mt-2">
        <h3 class="font-semibold">Summary</h3>
      </div>
      <div class="flex flex-wrap">
        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/TransactionIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Total No. of Transactions</p>
            <b>{{ (Paymentdetails.totalNumberOfTransaction || 0).toLocaleString() }}</b>
          </div>
        </div>

        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/RevenueIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Total Revenue</p>
            <b>₦ {{ formatAmount(Paymentdetails.totalRevenue) }} </b>
          </div>
        </div>

        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/EarningIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Total Earnings</p>
            <b>₦ {{ formatAmount(Paymentdetails.totalEarning) }} </b>
          </div>
        </div>

        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/PlatformIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Platform commission</p>
            <b>₦ {{ formatAmount(Paymentdetails.totalPlatformCommission) }} </b>
          </div>
        </div>


        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/EarningIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Platform Collection</p>
            <b>₦ {{ formatAmount(Paymentdetails.platformCollection) }} </b>
          </div>
        </div>

        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/TransactionIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Partner Collection</p>
            <b>₦ {{ formatAmount(Paymentdetails.partnerCollection) }} </b>
          </div>
        </div>

        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/EarningIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Payouts</p>
            <b>₦ {{ formatAmount(Paymentdetails.payout) }} </b>
          </div>
        </div>

        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/TransactionIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Payout balance</p>
            <b>₦ {{ formatAmount(Paymentdetails.payoutBalance) }} </b>
          </div>
        </div>

        <div class="summary_item">
          <div class="w-10 mx-2 flex justify-center items-center">
            <img src="../icons/RevenueIcon.svg" class="w-11/12" />
          </div>
          <div>
            <p>Total Refunds</p>
            <b>₦ {{ (Paymentdetails.totalRefund || 0).toLocaleString() }} </b>
          </div>
        </div>

      </div>
    </section>

    <section class="bg-white">
      <TableFilter :currentTier="currentTier" @setQueryparams="sortItemProps" @openmodal="isViewHistory = true"
        @openPriceInfo="isPriceInfo = true" @setStatusChanges="setStatusChanges" />
      <div class="flex justify-end px-3">
        <div v-if="interval == 'custom'" class="flex justify-end w-full px-4 pt-0">
          <div class="date-picker flex items-center justify-center">
            <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />
            <span class="pr-2 opacity-50"> to </span>
            <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
          </div>
        </div>
        <div>
          <el-dropdown trigger="click" class="h-full w_semi">
            <div class="drp-content">
              <span>
                <img src="../icons/CalendarIcon.svg" />
                <abbr class="vrt_line"></abbr>
                <span class="inline-block whitespace-nowrap">{{ filterTitle }}</span>
              </span>
              <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <button @click="setFilterType('today', 'Today')">Today</button>
              </el-dropdown-item>

              <el-dropdown-item>
                <button @click="setFilterType('week', 'This week')">This week</button>
              </el-dropdown-item>

              <el-dropdown-item>
                <button @click="setFilterType('month', 'This month')">This month</button>
              </el-dropdown-item>

              <el-dropdown-item>
                <button @click="setFilterType('year', 'This year')">This year</button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button @click="setFilterType('all', 'All time')">All time</button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button @click="setFilterType('custom', 'Custom')">Custom</button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <EarnPayTable :transactions="allTransactions" />
      <PaginationControl :total="totalPayment" :pageNumber="sortOptions.pageNumber"
        @pageNumber="setPageDisplayTransaction" @pageSize="setNumDisplaytransaction" />
    </section>

    <ViewHistory :showModal="isViewHistory" @close-modal="isViewHistory = false" />
    <PriceInfo :showModal="isPriceInfo" @close-modal="isPriceInfo = false" />
  </div>
</template>

<script>
import moment from "moment";
import TableFilter from "../modules/EarnTableFilter.vue";
import EarnPayTable from "../modules/EarnPayTable.vue";
import ViewHistory from "../modals/ViewHistory.vue";
import PriceInfo from "../modals/PriceInfo.vue";
import debounce from "@/utilities/debounce";
import ArrowDownBlackIcon from "@/components/UI/svgs/ArrowDownBlackIcon.vue";
// import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/pagination";

export default {
  components: {
    TableFilter,
    // PageHeader,
    PaginationControl,
    EarnPayTable,
    ViewHistory,
    ArrowDownBlackIcon,
    PriceInfo
  },
  data() {
    return {
      loading: true,
      isViewHistory: false,
      isPriceInfo: false,
      allTransactions: [],
      Paymentdetails: {},
      currentTier: {},
      searchString: "",
      interval: "month",
      totalPayment: null,
      filterTitle: 'This Month',
      statusFilter: '',
      startDate: '',
      endDate: "",
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
      },
    };
  },
  watch: {
    sortOptions() {
      // this.getAllRecievables();
    },
    "searchString": debounce(function () {
      this.getAllEarnAndPay();
    }, 500),
    earnPayload() {
      if (this.interval == 'custom' && this.startDate && this.endDate && (this.endDate > this.startDate)) {
        this.getAllEarnAndPay();
        return
      }
      this.getAllEarnAndPay();
    }
  },
  mounted() {
    this.getAllEarnAndPay()
    this.getViewTierHistory()
    this.getAllRecievables()
  },
  computed: {
    earnPayload() {
      return {
        customerType: '3PL',
        searchTerm: this.sortOptions.searchString,
        interval: this.interval,
        statusFilter: this.statusFilter,
        pageSize: this.sortOptions.pageSize,
        pageNumber: this.sortOptions.pageNumber,
        ...(this.startDate ? { startDate: moment(this.startDate).format('YYYY-MM-DD') } : {}),
        ...(this.endDate ? { endDate: moment(this.endDate).format('YYYY-MM-DD') } : {}),
      }
    },
  },
  methods: {
    setStatusChanges(val) {
      this.statusFilter = val
    },
    setFilterType(val, title) {
      this.interval = val
      this.filterTitle = title
    },
    formatAmount(number) {
      return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    },
    goBack() {
      this.$router.go(-1)
    },
    setNumDisplaytransaction(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplayTransaction(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
    sortItemProps(val) {
      this.searchString = val.searchString
      this.sortOptions = { ...this.sortOptions, ...val };
    },
    async getAllEarnAndPay() {
      let response = await this.$_getEarnAndPayout(this.earnPayload);
      this.allTransactions = response.data.data.allTransaction;
      this.Paymentdetails = response.data.data;
      this.totalPayment = response.data?.data?.pagination?.totalRecords
    },
    async getViewTierHistory() {
      let response = await this.$_getViewCurrentTeir({ customerType: '3PL' })
      this.currentTier = response.data.data
    },

    // async getAllRecievables() {
    //   this.loading = true;
    //   try {
    //     let response = await this.$_getTransaction(this.payload);

    //   } catch (error) {
    //     this.handleError(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
  },
}
</script>

<style lang="scss" scoped>
.btn_arrow {
  @apply inline-flex items-center
}

.lft_arrow {
  @apply inline-block rotate-90 w-3 mr-2
}

.summary_item {
  @apply w-full sm:w-[calc(50%-8px)] xl:w-[calc(33.333333%-8px)] bg-gray-100 flex items-center py-2 rounded-md mb-3 mr-2
}

.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}

.w_semi {
  @apply w-[200px] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}

.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}
</style>
